module.exports = __webpack_public_path__ + "static/img/leng y mat.ee43f273.png";